webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(849),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */])

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
    }
  ]
}));


/***/ }),

/***/ 15:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(846),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(56)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(848),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_vue_bs_drawer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_vue_bs_drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__src_vue_bs_drawer__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










// import VueBsDrawer from './../dist/vue-bs-drawer.min.js'
// import './../dist/vue-bs-drawer.min.css'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default.a)

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('bs-drawer', __WEBPACK_IMPORTED_MODULE_8__src_vue_bs_drawer___default.a)
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
})


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(27);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'app',
  data: function data() {
    var _ref;

    return {
      rightBtnStyles: [{}, (_ref = {
        top: '0',
        bottom: '0',
        marginTop: '54px',
        width: '20px',
        height: '100%',
        borderRadius: '50%',
        border: '0'
      }, (0, _defineProperty3.default)(_ref, 'borderRadius', '0'), (0, _defineProperty3.default)(_ref, 'background', 'rgba(0, 0, 0, 0.2)'), (0, _defineProperty3.default)(_ref, 'fill', 'green'), _ref), {
        background: 'rgba(150, 5, 0, 0.2)',
        padding: '0 5px',
        borderRadius: '0',
        marginTop: '54px',
        marginRight: '15px',
        height: '100%',
        top: '0'
      }, (0, _defineProperty3.default)({
        background: 'rgba(4, 80, 0, 0.4)',
        verticalAlign: 'middle',
        padding: '0',
        height: '40px',
        borderRadius: '0'
      }, 'background', 'rgba(0, 0, 0, 0.2)')],
      styleIndex: 0
    };
  },

  methods: {
    closeRight: function closeRight() {
      this.$refs.rightDrawer.closeDrawer();
      this.$refs.rightDrawer2.closeDrawer();
    },
    closeLeft: function closeLeft() {
      this.$refs.leftDrawer.closeDrawer();
    },
    toggleStyle: function toggleStyle() {
      this.styleIndex === 3 ? this.styleIndex = 0 : this.styleIndex += 1;
    }
  }
};

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'hello',
  data: function data() {
    return {
      msg: 'Vue Bootstrap Drawer Example App'
    };
  }
};

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var icons = {}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            _vue2.default.util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        _vue2.default.util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
};

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'vue-bs-drawer',
  data: function data() {
    return {
      open: this.showDrawer,
      sidebarSizes: ['sm', 'md', 'lg']
    };
  },

  props: {
    side: {
      type: String,
      default: 'left'
    },
    showDrawer: {
      type: Boolean,
      default: true
    },
    bg: {
      type: String,
      default: '#f5f5f5'
    },
    btnTop: {
      type: String,
      default: '45%'
    },
    btnStyle: {
      type: Object,
      default: function _default() {
        return {
          top: this.btnTop
        };
      }
    },
    btnMainClass: {
      type: String,
      default: 'bs-drawer__btn'
    },
    btnOpenClass: {
      type: String,
      default: 'bs-drawer__btn-open'
    },
    showToggleBtn: {
      type: Boolean,
      default: true
    },
    sidebar: {
      type: String,
      validator: function validator(value) {
        return ['sm', 'md', 'lg'].indexOf(value) > -1;
      }
    }
  },
  methods: {
    toggleOpen: function toggleOpen() {
      this.open = !this.open;
    },
    openDrawer: function openDrawer() {
      this.open = true;
    },
    closeDrawer: function closeDrawer() {
      this.open = false;
    }
  },
  computed: {
    isSideBar: function isSideBar() {
      return this.sidebarSizes.indexOf(this.sidebar) > -1;
    },
    hiddenContentClass: function hiddenContentClass() {
      return 'hidden-' + this.sidebar + '-down';
    },
    btnSideClass: function btnSideClass() {
      return this.btnMainClass + '-' + this.side;
    },
    btnClass: function btnClass() {
      return this.isSideBar ? this.btnMainClass + ' hidden-' + this.sidebar + '-up ' + this.btnSideClass : this.btnMainClass + ' ' + this.btnSideClass;
    },
    contentClass: function contentClass() {
      var show = 'bs-drawer__' + this.sidebar + '-show';
      return this.isSideBar ? '' + show : '';
    },
    sideClass: function sideClass() {
      var side = this.contentClass + ' bs-drawer__' + this.side;
      return this.open ? side + ' bs-drawer__drawer-open' : side;
    },
    btnText: function btnText() {
      if (this.customText) {
        return this.customText;
      } else {
        if (this.side === 'left') {
          return this.open ? '<' : '>';
        } else {
          return this.open ? '>' : '<';
        }
      }
    },
    btnCustomStyle: function btnCustomStyle() {
      var style = this.btnStyle;
      if ((0, _keys2.default)(this.btnStyle).indexOf('top') < 0) {
        this.btnTop ? style.top = this.btnTop : '45%';
      }
      return style;
    }
  },
  watch: {
    open: function open(newValue) {
      newValue ? this.$emit('bs-drawer-opened') : this.$emit('bs-drawer-closed');
    }
  }
};

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(55)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(847),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cb3c81e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "",
      "type": "inverse",
      "variant": "success",
      "sticky": true
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "#"
    }
  }, [_c('span', [_vm._v("Vue BS Drawer Example")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item', [_vm._v("Support")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Docs")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Contact Us")])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Lang",
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("EN")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("RU")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("FA")])], 1), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("User")])]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("Profile")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("Signout")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('bs-drawer', {
    ref: "leftDrawer",
    staticClass: "col-10 col-sm-3 col-md-3 col-lg-2 bs-drawer__animate",
    attrs: {
      "side": "left",
      "showDrawer": false,
      "showToggleBtn": true,
      "btnTop": "195px",
      "bg": "transparent",
      "sidebar": "md"
    },
    on: {
      "bs-drawer-opened": _vm.closeRight
    }
  }, [_c('b-card', {
    staticClass: "ml-3 my-3",
    attrs: {
      "header": "Sidebar Nav"
    }
  }, [_c('b-nav', {
    attrs: {
      "vertical": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Link")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Another Link")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "px-4 col-12 col-md-9 col-lg-10 offset-md-3 offset-lg-2"
  }, [_c('router-view')], 1), _vm._v(" "), _c('bs-drawer', {
    ref: "rightDrawer",
    staticClass: "col-9 col-sm-8 col-md-4 col-lg-4 col-xl-2 bs-drawer__animate",
    attrs: {
      "side": "right",
      "showDrawer": false,
      "btnStyle": _vm.rightBtnStyles[_vm.styleIndex],
      "btnTop": 0
    },
    on: {
      "bs-drawer-opened": _vm.closeLeft
    }
  }, [_c('b-nav', {
    attrs: {
      "vertical": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Link")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Another Link")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.toggleStyle
    }
  }, [_vm._v("Button styles")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('b-card', [_c('h5', [_vm._v("Left drawer displayed as a Reponsive Sidebar. "), _c('span', {
    staticClass: "font-italic"
  }, [_vm._v("Resize the window to test")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-card', {
    staticClass: "text-right"
  }, [_c('h5', [_vm._v("Right drawer hidden on page load.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-card', [_c('h5', [_vm._v("Customize button styles")]), _vm._v(" "), _c('p', [_vm._v("Use a style object e.g.")]), _vm._v(" "), _c('pre', [_c('code', [_vm._v("\n     {\n        background: 'rgba(150, 5, 0, 0.2)',\n        padding: '0 5px',\n        marginTop: '56px',\n        marginRight: '15px',\n        height: '100%',\n        top: '0'\n      }\n    ")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 848:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bs-drawer",
    class: _vm.sideClass
  }, [_c('div', {
    staticClass: "bs-drawer__content"
  }, [_c('div', {
    staticClass: "bs-drawer__nav-container",
    class: "bs-drawer__nav-container-" + _vm.side + " " + _vm.contentClass,
    style: ({
      backgroundColor: _vm.bg
    })
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showToggleBtn) ? _c('div', {
    staticClass: "bs-drawer__btn-container",
    class: ("bs-drawer__btn-container-" + _vm.side)
  }, [_c('button', {
    class: [_vm.btnClass, _vm.open ? _vm.btnOpenClass : ''],
    style: (_vm.btnCustomStyle),
    on: {
      "click": _vm.toggleOpen
    }
  }, [(_vm.open) ? _vm._t("opened", [_c('svg', {
    staticClass: "bs-drawer__svg",
    attrs: {
      "width": "11.428571428571429",
      "height": "16",
      "viewBox": "0 0 1280 1792"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1171 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z"
    }
  }), _vm._v(" \b\n            ")])]) : _vm._t("closed", [_c('svg', {
    staticClass: "bs-drawer__svg",
    attrs: {
      "width": "11.428571428571429",
      "height": "16",
      "viewBox": "0 0 1280 1792"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1171 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z"
    }
  }), _vm._v(" \b\n            ")])])], 2)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 849:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ })

},[20]);


// WEBPACK FOOTER //
// ../js/app.7152147ed9f6f733ad7c.js